export default {
  inside: () => import("/home/denis/sources/nova-plateform-web/layouts/inside.vue").then(m => m.default || m)
}